import React from "react";

/** Subtle film grain overlay, absolute to its parent. */
export default function Grain({ className = "" }) {
  return <div className={`grain absolute inset-0 pointer-events-none z-[1] ${className}`} />;
}
